// GENERATED FILE — do not edit. Source of truth: agents/shared/. Sync: node scripts/sync-agent-shared.mjs
// Agent-driven UI actions for DefectSnap — validated at the gateway AND
// re-validated by the browser dispatcher before executing (defence in depth).
import { validateAgainstSchema, objectSchema } from './validate.js';

export const APP_ROUTES = ['dashboard', 'properties', 'inspections', 'report-presets', 'template-editor', 'billing'];

export const HIGHLIGHT_TARGETS = ['preset-create-form', 'preset-list', 'form-builder', 'form-preview'];

export const DOM_ACTIONS = {
  navigateRoute: objectSchema(
    { route: { type: 'string', enum: APP_ROUTES } },
    ['route'],
  ),
  highlightTarget: objectSchema(
    { target: { type: 'string', enum: HIGHLIGHT_TARGETS } },
    ['target'],
  ),
  // Renders quick-action buttons in the assistant panel; clicking one sends
  // its prompt back as a user message. This is how the agent "presents
  // buttons and navigators" directly to the page.
  suggestActions: objectSchema(
    {
      actions: {
        type: 'array',
        minItems: 1,
        maxItems: 4,
        items: objectSchema(
          {
            label: { type: 'string', minLength: 1, maxLength: 60 },
            prompt: { type: 'string', minLength: 1, maxLength: 500 },
          },
          ['label', 'prompt'],
        ),
      },
    },
    ['actions'],
  ),
  // Tells the form builder on /app/report-presets to load a server-owned
  // draft and render it live (server owns the artifact; UI is a view).
  loadDraft: objectSchema(
    { draft_id: { type: 'string', minLength: 8, maxLength: 64 } },
    ['draft_id'],
  ),
};

export function validateDomAction(action, params) {
  const schema = DOM_ACTIONS[action];
  if (!schema) return { ok: false, errors: [`unknown dom action: ${String(action)}`] };
  const errors = validateAgainstSchema(schema, params ?? {});
  return { ok: errors.length === 0, errors };
}
